import { Component, Input } from '@angular/core';
import { isString } from 'lodash-es';
import { isArray } from 'lodash-es';
import { isEmpty } from 'lodash-es';

@Component({
  selector: 'app-error-notification',
  templateUrl: './error-notification.component.html',
})

export class ErrorNotificationComponent {
  private _errors: Array<string> = [];
  constructor() { }
  /**
   * 'errors' is expected to be an input of either a string or an array of strings
   */
  @Input() set errors(errors: Array<string> | any) {
    // Caller just passed in a string instead of an array of strings
    if (isEmpty(errors)) {
      this._errors = [];
    }

    if (isString(errors)) {
      this._errors = [errors];
      return;
    }
    // Caller passed in array, assuming it is a string array
    if (isArray(errors)) {
      this._errors = errors;
      return;
    }
    // At this point just set it to whatever might have been passed in and let
    // the user debug when it is broken.
    this._errors = errors;
  }

  get errors() {
    return this._errors;
  }
}
